import {
  isEmail,
  isRequired,
  isNumeric,
  isPositive,
  isWholeNumber,
  isUKDateOrYear,
  isBetween,
  isOnlyDateChars,
  ageValidation,
  isSafeForRender,
  isPersonName,
  maxLength
} from '../../validation/rules';
import { ruleRunner } from '../../validation/ruleRunner';
import {
  DisplayTypeConstants,
  SpecificAnswerTypes
} from '../../helpers/constants';
import {
  getFieldInfoFromName,
  getQuestionIdFromAlias
} from '../../features/questionnaire/unrefactored/fields';

export const fieldValidations = (id, name, answerType, requiredAnswer) => {
  let result = [];

  if (requiredAnswer) {
    result.push(ruleRunner(id, name, requiredAnswer, isRequired));
  }

  switch (answerType.displayType) {
    case DisplayTypeConstants.EmailText:
      result.push(ruleRunner(id, name, requiredAnswer, isEmail));
      break;
    case DisplayTypeConstants.NumericText:
      result.push(
        ruleRunner(
          id,
          name,
          requiredAnswer,
          isNumeric,
          isPositive,
          isWholeNumber
        )
      );

      if (answerType.id === SpecificAnswerTypes.LoopCount) {
        result.push(
          ruleRunner(id, name, requiredAnswer, fieldName =>
            isBetween(fieldName, 0, 20)
          )
        );
      }
      break;
    case DisplayTypeConstants.DateYearText:
      result.push(
        ruleRunner(id, name, requiredAnswer, isOnlyDateChars, isUKDateOrYear)
      );
      break;
    default:
      break;
  }

  const currentField = getFieldInfoFromName(id);

  const questionId = currentField.questionId;

  const freeTextQuestionIds = [
    3, 39, 40, 42, 44, 47, 59, 60, 66, 67, 68, 69, 74, 152, 154, 156, 158, 160,
    163
  ];

  if (freeTextQuestionIds.includes(questionId)) {
    result.push(
      ruleRunner(
        id,
        name,
        requiredAnswer,
        isRequired,
        isSafeForRender,
        maxLength(150)
      )
    );
  }

  const anyOtherInfoQuestionId = getQuestionIdFromAlias('AnyOtherInformation');
  if (questionId === anyOtherInfoQuestionId) {
    result.push(
      ruleRunner(
        id,
        name,
        requiredAnswer,
        isRequired,
        isSafeForRender,
        maxLength(500)
      )
    );
  }

  const relativeNameQuestionId = getQuestionIdFromAlias('RelativeName');
  if (questionId === relativeNameQuestionId) {
    result.push(
      ruleRunner(
        id,
        name,
        requiredAnswer,
        isRequired,
        isSafeForRender,
        isPersonName,
        maxLength(55)
      )
    );
  }

  const yearOfDeathQuestionId = getQuestionIdFromAlias('YearOfDeath');
  const ageOfDiagnosesQuestionId = getQuestionIdFromAlias('AgeOfDiagnosis');

  const ageValidationQuestions = [
    yearOfDeathQuestionId,
    ageOfDiagnosesQuestionId
  ];

  if (ageValidationQuestions.includes(questionId)) {
    result.push(
      ruleRunner(id, name, requiredAnswer, (value, state, fieldName) =>
        ageValidation(value, state, fieldName)
      )
    );
  }

  return result;
};
